import React from 'react';
import { BookingProvider } from './components/BookingContext';
import { BookingModal } from './components/BookingModal';
import { Navigation } from './components/Navigation';
import { HeroSection } from './components/HeroSection';
import { InvitationSection } from './components/InvitationSection';
import { ProtocolSection } from './components/ProtocolSection';
import { EveningSection } from './components/EveningSection';
import { DetailsSection } from './components/DetailsSection';
import { RSVPSection } from './components/RSVPSection';
import { Footer } from './components/Footer';
export function App() {
  return <BookingProvider data-id="element-0">
      <div className="min-h-screen w-full bg-bc-bg text-bc-bone" data-id="element-1">
        <Navigation data-id="element-2" />
        <HeroSection data-id="element-3" />
        <InvitationSection data-id="element-4" />
        <ProtocolSection data-id="element-5" />
        <EveningSection data-id="element-6" />
        <DetailsSection data-id="element-7" />
        <RSVPSection data-id="element-8" />
        <Footer data-id="element-9" />
      </div>
      <BookingModal data-id="element-10" />
    </BookingProvider>;
}